"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TeacherRefLesson = void 0;
var _jsxRuntime = require("react/jsx-runtime");
const TeacherRefLesson = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
        d: "M10.3,47.69H54.7c4.31,0,7.8-3.49,7.8-7.8V14.82c0-4.31-3.49-7.8-7.8-7.8H10.3c-4.31,0-7.8,3.49-7.8,7.8v25.06\r C2.5,44.2,5.99,47.69,10.3,47.69z"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "26.2",
          y1: "52.53",
          x2: "25.06",
          y2: "57.13"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "38.8",
          y1: "52.53",
          x2: "39.94",
          y2: "57.13"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
        x1: "20.36",
        y1: "57.98",
        x2: "44.64",
        y2: "57.98"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("g", {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M49.96,41.96l-12.44-12.5c1.55-4.42,0.57-9.52-2.96-13.05c-3.27-3.27-7.89-4.35-12.06-3.26l6.45,6.45\r c0.35,0.35,0.49,0.87,0.36,1.35l-1.48,5.52c-0.13,0.48-0.51,0.86-0.99,0.99l-5.52,1.48c-0.48,0.13-1-0.01-1.35-0.36l-6.43-6.43\r c-1,3.99-0.08,8.41,2.81,11.59c3.72,4.1,9.45,5.14,14.2,3.14l5.09,5.09"
        })
      })]
    })
  });
};
exports.TeacherRefLesson = TeacherRefLesson;